import { useSettingStore } from "./stores/settingStore";
import { useSessionStore } from "./stores/sessionStore";

import { ReactComponent as HomeIcon } from "./assets/icons/house-svgrepo-com.svg";
import { ReactComponent as CustomerIcon } from "./assets/icons/man-svgrepo-com.svg";
import { ReactComponent as ProductIcon } from "./assets/icons/box-svgrepo-com.svg";
import { ReactComponent as ServiceIcon } from "./assets/icons/heart-svgrepo-com.svg";
import { ReactComponent as BillIcon } from "./assets/icons/shopping-card-svgrepo-com.svg";
import { ReactComponent as OrgIcon } from "./assets/icons/building-svgrepo-com.svg";
import { ReactComponent as BranchIcon } from "./assets/icons/shop-svgrepo-com.svg";
import { ReactComponent as EmployeeIcon } from "./assets/icons/id-card-svgrepo-com.svg";
import { ReactComponent as SettingIcon } from "./assets/icons/wrench-svgrepo-com.svg";
import { ReactComponent as MarketPlaceIcon } from "./assets/icons/shopping-bag-svgrepo-com.svg";

import Index from "./views/Index";
import SubMenuProductService from "./views/SubMenuProductService";

import UserProfile from "views/user/UserProfile";

import AdminBusinessType from "views/admin/AdminBusinessType";
// import AdminCustomer from "views/admin/AdminCustomer";
// import AdminAddCustomer from "views/admin/AdminAddCustomer";
// import AdminManagePackage from "views/admin/AdminManagePackage";
// import AdminAddPackage from "views/admin/AdminAddPackage";
// import AdminProduct from "views/admin/AdminProduct";
// import AdminOrderPackage from "views/admin/AdminOrderPackage";
// import AdminOrderPackageEdit from "views/admin/AdminOrderPackageEdit";
// import AdminOrderPeice from "views/admin/AdminOrderPeice";
// import AdminOrderPeiceEdit from "views/admin/AdminOrderPeiceEdit";
// import AdminOrderOrg from "views/admin/AdminOrderOrg";
// import AdminAddRecordOrderOrg from "views/admin/AdminAddRecordOrderOrg";
// import AdminOrderOrgEdit from "views/admin/AdminOrderOrgEdit";
// import AdminRecordOrderPackage from "views/admin/AdminRecordOrderPackage";
// import AdminProductPackingCustomer from "views/admin/AdminProductPackingCustomer";
// import PackageSystemAdmin from "views/admin/PackageSystemAdmin";
// import BuyPackageSystemAdmin from "views/admin/BuyPackageSystemAdmin";
// import PackageSystemRegisterAdmin from "views/admin/PackageSystemRegisterAdmin";
import AdminOrganization from "views/admin/AdminOrganization";
import AdminBranch from "views/admin/AdminBranch";
import AdminAddBranch from "views/admin/AdminAddBranch";
import AdminEditBranch from "views/admin/AdminEditBranch";
import AdminEmployee from "views/admin/AdminEmployee";
import AdminAddEmployee from "views/admin/AdminAddEmployee";
import AdminEditEmployee from "views/admin/AdminEditEmployee";

import Customer from "views/user/Customer";
import AddCustomer from "views/user/AddCustomer";
import EditCustomer from "views/user/EditCustomer";
import ManagePackage from "views/user/ManagePackage";
import AddPackage from "views/user/AddPackage";
import EditPackage from "views/user/EditPackage";
import Product from "views/user/Product";
import ProductCustomer from "views/user/ProductCustomer";
// import ManageService from "views/user/ManageService";
// import ProductGeneral from "views/user/ProductGeneral";
// import ProductPeice from "views/user/ProductPeice";
// import ProductPeiceDetail from "views/user/ProductPeiceDetail";
// import ProductOrg from "views/user/ProductOrg";
// import ProductOrgDetail from "views/user/ProductOrgDetail";
// import ProductOrgType from "views/user/ProductOrgType";
// import OrderPackage from "views/user/OrderPackage";
// import BuyPackage from "views/user/BuyPackage";
// import ManagePromotion from "views/user/ManagePromotion";
// import PromotionAdd from "views/user/PromotionAdd";
import RecordOrderPackage from "views/user/RecordOrderPackage";
// import AddRecordOrderPackage from "views/user/AddRecordOrderPackage";
// import CustomerPackage from "views/user/CustomerPackage";
// import ManageOrderPackage from "views/user/ManageOrderPackage";
// import OrderPackageEdit from "views/user/OrderPackageEdit";

// import OrderPeice from "views/user/OrderPeice";
// import RecordOrderPeice from "views/user/RecordOrderPeice";
// import ManageOrderPeice from "views/user/ManageOrderPeice";
// import AddRecordOrderPeice from "views/user/AddRecordOrderPeice";
// import OrderPeiceEdit from "views/user/OrderPeiceEdit";
// import ManagePromotionPeice from "views/user/ManagePromotionPeice";
// import OrderPeiceNoPay from "views/user/OrderPeiceNoPay";

// import OrderOrg from "views/user/OrderOrg";
// import RecordOrderOrg from "views/user/RecordOrderOrg";
// import AddRecordOrderOrg from "views/user/AddRecordOrderOrg";
// import ManageOrderOrg from "views/user/ManageOrderOrg";
// import OrderOrgEdit from "views/user/OrderOrgEdit";

// import ProductPackingCustomer from "views/user/ProductPackingCustomer";

// import Organization from "views/user/Organization";
// import AdminAddRecordOrderPeice from "views/admin/AdminAddRecordOrderPeice";

import Order from "views/user/Order";
import OrderList from "views/user/OrderList";
import AddRecordOrder from "views/user/AddRecordOrder";
import OrderBuyPackage from "views/user/OrderBuyPackage";
import OrderBillOrg from "views/user/OrderBillOrg";
import EditOrderBillOrg from "views/user/EditOrderBillOrg";
import AddRecordOrderNoPackage from "views/user/AddRecordOrderNoPackage";
import EditBranch from "views/user/EditBranch";
import Setting from "views/user/Setting";
import Marketplace from "views/user/Marketplace";

import { useAuth } from "./auth/AuthContext";

export const useRoutes = () => {
  const { user, role } = useAuth();

  const brId = useSessionStore((s) => s.profile?.brId);
  const billMode = useSettingStore((s) => s.getBillMode(brId));

  const hiddenOrder = billMode !== 1;
  const hiddenOrderList = billMode !== 1;
  const hiddenOrderOrg = billMode !== 0;

  return [
    {
      path: "/index",
      name: "หน้าแรก",
      icon: <HomeIcon />,
      component: <Index />,
      roles: ["admin"],
    },
    {
      path: "/submenu-product-service",
      name: "หน้าแรก",
      component: <SubMenuProductService />,
      roles: ["admin"],
      hidden: true,
    },
    {
      path: "/user-profile",
      name: "ข้อมูลส่วนตัว",
      icon: "ni ni-tv-2 text-primary",
      component: <UserProfile />,
      roles: ["admin", "user"],
      hidden: true,
    },
    {
      name: "จัดการลูกค้า",
      icon: <CustomerIcon />,
      roles: ["admin"],
      children: [
        {
          path: "/business-type",
          name: "ประเภทธุรกิจ",
          component: <AdminBusinessType />,
          roles: ["admin"],
        },
        {
          path: "/customer",
          name: "ข้อมูลลูกค้า",
          component: <Customer />,
          roles: ["admin"],
        },
        {
          path: "/add-customer",
          name: "ข้อมูลลูกค้า",
          component: <AddCustomer />,
          roles: ["admin"],
          hidden: true,
        },
        {
          path: "/edit-customer",
          name: "ข้อมูลลูกค้า",
          component: <EditCustomer />,
          roles: ["admin"],
          hidden: true,
        },
        {
          name: "สินค้า",
          path: "/product-customer",
          component: <ProductCustomer />,
          roles: ["admin"],
          hidden: true,
        },
      ],
    },
    {
      name: "สินค้า",
      path: "/product",
      icon: <ProductIcon />,
      component: <Product />,
      roles: ["admin"],
    },
    {
      name: "บริการ",
      path: "/manage-package",
      icon: <ServiceIcon />,
      component: <ManagePackage />,
      roles: ["admin"],
    },
    {
      path: "/add-package",
      name: "ซื้อแพ็คเกจ",
      component: <AddPackage />,
      roles: ["admin"],
      hidden: true,
    },
    {
      path: "/edit-package",
      name: "ซื้อแพ็คเกจ",
      component: <EditPackage />,
      roles: ["admin"],
      hidden: true,
    },
    {
      name: "บิล",
      icon: <BillIcon />,
      roles: ["admin"],
      children: [
        {
          path: "/order",
          name: "เปิดบิล",
          component: <Order />,
          roles: ["admin"],
          hidden: hiddenOrder,
        },
        {
          path: "/order-list",
          name: "รายการบิล",
          component: <OrderList />,
          roles: ["admin"],
          hidden: hiddenOrderList,
        },
        {
          path: "/order-buy-package",
          name: "ซื้อแพ็คเกจ",
          component: <OrderBuyPackage />,
          roles: ["admin"],
          hidden: hiddenOrderOrg,
        },
        {
          path: "/order-bill-org",
          name: "เปิดบิล",
          component: <OrderBillOrg />,
          roles: ["admin"],
          hidden: hiddenOrderOrg,
        },
        {
          path: "/edit-order-bill-org",
          name: "เปิดบิล",
          component: <EditOrderBillOrg />,
          roles: ["admin"],
          hidden: true,
        },
      ],
    },
    {
      path: "/record-order-package",
      name: "บันทึก Order",
      component: <RecordOrderPackage />,
      roles: ["admin"],
      hidden: true,
    },
    {
      path: "/add-record-order",
      name: "บันทึก Order",
      component: <AddRecordOrder />,
      roles: ["admin"],
      hidden: true,
    },
    {
      path: "/add-record-order-no-package",
      name: "บันทึก Order",
      component: <AddRecordOrderNoPackage />,
      roles: ["admin"],
      hidden: true,
    },
    {
      path: "/organization",
      name: "ข้อมูลองค์กร",
      icon: <OrgIcon />,
      component: <AdminOrganization />,
      roles: ["admin"],
    },
    {
      path: "/branch",
      name: "ข้อมูลสาขา",
      icon: <BranchIcon />,
      component: <AdminBranch />,
      roles: ["admin"],
    },
    {
      path: "/add-branch",
      name: "สร้างข้อมูลองค์กร (ซ่อนไว้)",
      icon: "ni ni-planet text-blue",
      component: <AdminAddBranch />,
      roles: ["admin"],
      hidden: true,
    },
    {
      path: "/edit-branch",
      name: "สร้างข้อมูลองค์กร (ซ่อนไว้)",
      icon: "ni ni-planet text-blue",
      component: <AdminEditBranch />,
      roles: ["admin"],
      hidden: true,
    },
    {
      path: "/employee",
      name: "ข้อมูลผู้ใช้",
      icon: <EmployeeIcon />,
      component: <AdminEmployee />,
      roles: ["admin"],
    },
    {
      path: "/add-employee",
      name: "ข้อมูลผู้ใช้",
      component: <AdminAddEmployee />,
      roles: ["admin"],
      hidden: true,
    },
    {
      path: "/edit-employee",
      name: "ข้อมูลผู้ใช้",
      component: <AdminEditEmployee />,
      roles: ["admin"],
      hidden: true,
    },
    // {
    //   name: "รายงาน",
    //   icon: <ChartIcon  />,
    //   roles: ["admin"],
    //   children: [
    //     {
    //       path: "/manage-package",
    //       name: "ยอดขายแพ็คเกจ",
    //       component: <ManagePackage />,
    //       roles: ["admin"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: " Order แพ็คเกจ",
    //       component: <ManagePackage />,
    //       roles: ["admin"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: " Order รายชิ้น",
    //       component: <ManagePackage />,
    //       roles: ["admin"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: " Order องค์กร",
    //       component: <ManagePackage />,
    //       roles: ["admin"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: "รับส่งผ้า",
    //       component: <ManagePackage />,
    //       roles: ["admin"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: "ชำระเงินลูกค้าทั่วไป",
    //       component: <ManagePackage />,
    //       roles: ["admin"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: "ค้างชำระแพ็คเกจ",
    //       component: <ManagePackage />,
    //       roles: ["admin"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: "ค้างชำระรายชิ้น",
    //       component: <ManagePackage />,
    //       roles: ["admin"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: "รายการลูกค้าใหม่",
    //       component: <ManagePackage />,
    //       roles: ["admin"],
    //     },
    //   ],
    // },
    {
      path: "/setting",
      name: "ตั้งค่า",
      icon: <SettingIcon />,
      component: <Setting />,
      roles: ["admin"],
    },
    {
      path: "/marketplace",
      name: "Marketplace",
      icon: <MarketPlaceIcon />,
      component: <Marketplace />,
      roles: ["admin"],
    },

    ///// role user
    {
      path: "/index",
      name: "หน้าแรก",
      icon: <HomeIcon />,
      component: <Index />,
      roles: ["user"],
    },
    {
      path: "/submenu-product-service",
      name: "หน้าแรก",
      component: <SubMenuProductService />,
      roles: ["user"],
      hidden: true,
    },
    {
      name: "บิล",
      icon: <BillIcon />,
      roles: ["user"],
      children: [
        {
          path: "/order",
          name: "เปิดบิล",
          component: <Order />,
          roles: ["user"],
          hidden: hiddenOrder,
        },
        {
          path: "/order-list",
          name: "รายการบิล",
          component: <OrderList />,
          roles: ["user"],
          hidden: hiddenOrderList,
        },
        {
          path: "/order-buy-package",
          name: "ซื้อแพ็คเกจ",
          component: <OrderBuyPackage />,
          roles: ["user"],
          hidden: hiddenOrderOrg,
        },
        {
          path: "/order-bill-org",
          name: "เปิดบิล",
          component: <OrderBillOrg />,
          roles: ["user"],
          hidden: hiddenOrderOrg,
        },
        {
          path: "/edit-order-bill-org",
          name: "เปิดบิล",
          component: <EditOrderBillOrg />,
          roles: ["user"],
          hidden: true,
        },
      ],
    },
    {
      path: "/record-order-package",
      name: "บันทึก Order",
      component: <RecordOrderPackage />,
      roles: ["user"],
      hidden: true,
    },
    {
      path: "/add-record-order",
      name: "บันทึก Order",
      component: <AddRecordOrder />,
      roles: ["user"],
      hidden: true,
    },
    {
      path: "/add-record-order-no-package",
      name: "บันทึก Order",
      component: <AddRecordOrderNoPackage />,
      roles: ["user"],
      hidden: true,
    },
    {
      path: "/customer",
      name: "จัดการลูกค้า",
      icon: <CustomerIcon />,
      component: <Customer />,
      roles: ["user"],
    },
    {
      path: "/add-customer",
      name: "ข้อมูลลูกค้า",
      component: <AddCustomer />,
      roles: ["user"],
      hidden: true,
    },
    {
      path: "/edit-customer",
      name: "ข้อมูลลูกค้า",
      component: <EditCustomer />,
      roles: ["user"],
      hidden: true,
    },

    {
      path: "/add-customer",
      name: "สร้างข้อมูลองค์กร",
      icon: "ni ni-planet text-primary",
      component: <AddCustomer />,
      hidden: true,
      roles: ["user"],
    },
    {
      name: "สินค้า",
      path: "/product",
      icon: <ProductIcon />,
      component: <Product />,
      roles: ["user"],
    },
    {
      name: "บริการ",
      path: "/manage-package",
      icon: <ServiceIcon />,
      component: <ManagePackage />,
      roles: ["user"],
    },
    {
      path: "/add-package",
      name: "ซื้อแพ็คเกจ",
      component: <AddPackage />,
      roles: ["user"],
      hidden: true,
    },
    {
      path: "/edit-package",
      name: "ซื้อแพ็คเกจ",
      component: <EditPackage />,
      roles: ["user"],
      hidden: true,
    },
    {
      path: "/add-package",
      name: "ซื้อแพ็คเกจ",
      component: <AddPackage />,
      roles: ["user"],
      hidden: true,
    },
    {
      path: "/edit-organization-user",
      name: "ข้อมูลสาขา",
      icon: <BranchIcon />,
      component: <EditBranch />,
      roles: ["user"],
    },
    // {
    //   name: "รายงาน",
    //   icon: <ChartIcon  />,
    //   roles: ["user"],
    //   children: [
    //     {
    //       path: "/manage-package",
    //       name: "ยอดขายแพ็คเกจ",
    //       component: <ManagePackage />,
    //       roles: ["user"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: " Order แพ็คเกจ",
    //       component: <ManagePackage />,
    //       roles: ["user"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: " Order รายชิ้น",
    //       component: <ManagePackage />,
    //       roles: ["user"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: " Order องค์กร",
    //       component: <ManagePackage />,
    //       roles: ["user"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: "รับส่งผ้า",
    //       component: <ManagePackage />,
    //       roles: ["user"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: "ชำระเงินลูกค้าทั่วไป",
    //       component: <ManagePackage />,
    //       roles: ["user"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: "ค้างชำระแพ็คเกจ",
    //       component: <ManagePackage />,
    //       roles: ["user"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: "ค้างชำระรายชิ้น",
    //       component: <ManagePackage />,
    //       roles: ["user"],
    //     },
    //     {
    //       path: "/manage-package",
    //       name: "รายการลูกค้าใหม่",
    //       component: <ManagePackage />,
    //       roles: ["user"],
    //     },
    //   ],
    // },
    {
      path: "/setting",
      name: "ตั้งค่า",
      icon: <SettingIcon />,
      component: <Setting />,
      roles: ["user"],
    },
    {
      path: "/marketplace",
      name: "Marketplace",
      icon: <MarketPlaceIcon />,
      component: <Marketplace />,
      roles: ["user"],
    },
  ];
};
